// components
import itemsGridStyles from "@components/ItemsGrid/style.module.scss";
import itemsGridItemStyles from "@components/ItemsGrid/ItemsGridItem/style.module.scss";
import LazyImage from "@components/LazyImage";
import Spring from "@components/Spring";
import SimpleHeader from "@components/SimpleHeader";
import { lazy, useState } from "react";
import api from "@utils/api";

const ImageView = lazy(() => import("@layout/author/ImageView"));

const CommunityImages = ({ authorData }) => {
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [imagePath, setImagePath] = useState("");
  const [imagePrompt, setImagePrompt] = useState("");
  const [imageCreatedAt, setImageCreatedAt] = useState("");
  const [imageRes, setImageRes] = useState("");
  const [selected, setSelected] = useState("");
  const [id, setId] = useState();

  const imageData = authorData?.mangaimage_set?.reduce(
    (images, item) =>
      images.concat(
        item.image.map((img) => ({
          image: img.image,
          prompt: item.prompt,
          createdAt: item.created_at,
          imgRes: img.image_size,
          selected: img.selected,
          id: img.id,
        }))
      ),
    []
  );

  const handleImageView = (image, prompt, createdAt, imgRes, selected, id) => {
    setIsModalVisible2(true);
    setImagePath(image);
    setImagePrompt(prompt);
    setImageCreatedAt(createdAt);
    setImageRes(imgRes);
    setSelected(selected);
    setId(id);
  };

  const imageCount = imageData?.length;
  console.log("AUTHOR DATA", authorData);
  return (
    <>
      <SimpleHeader
        title={`Community (${imageCount})`}
        style={{ textAlign: "center", color: "#FCB808" }}
      />
      <div className="container">
        <div className={`${itemsGridStyles.grid} items-grid`} id="items">
          {imageData && imageData.length > 0
            ? imageData.map((item, index) => (
                <Spring key={index} index={index}>
                  <div
                    className={`${itemsGridItemStyles.wrapper} border-hover bg-primary`}
                  >
                    <div
                      className={`${itemsGridItemStyles.media} square border-10`}
                    >
                      <LazyImage
                        src={item.image}
                        //src={`http://127.0.0.1:8000${item.image}`}
                        alt="Item Image"
                        onClick={() =>
                          handleImageView(
                            item.image,
                            item.prompt,
                            item.createdAt,
                            item.imgRes,
                            item.selected,
                            item.id
                          )
                        }
                      />
                    </div>
                  </div>
                </Spring>
              ))
            : null}
        </div>
      </div>
      <ImageView
        isModalVisible2={isModalVisible2}
        setIsModalVisible2={setIsModalVisible2}
        imagePath={imagePath}
        imagePrompt={imagePrompt}
        imageCreatedAt={imageCreatedAt}
        imageRes={imageRes}
        selected={selected}
        setSelected={setSelected}
        id={id}
      />
    </>
  );
};

export default CommunityImages;
